import { render, staticRenderFns } from "./CellRendererActions.vue?vue&type=template&id=1513f2dc&scoped=true"
import script from "./CellRendererActions.vue?vue&type=script&lang=js"
export * from "./CellRendererActions.vue?vue&type=script&lang=js"
import style0 from "./CellRendererActions.vue?vue&type=style&index=0&id=1513f2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513f2dc",
  null
  
)

export default component.exports